import { combineReducers } from 'redux';

import * as actionTypes from '../action-creator/actionTypes';

const byId = (state = {}, action) => {
  switch(action.type){
    case actionTypes.FETCH_PERSONAS_REQUEST:
      return {};
    case actionTypes.FETCH_PERSONAS_SUCCESS:
      return action.byId;
    case actionTypes.CREATE_PERSONA_SUCCESS:
      return {
        ...state,
        ...action.byId
      }
    default:
      return state;
  }
}

const ids = (state = [], action) => {
  switch(action.type){
    case actionTypes.FETCH_PERSONAS_REQUEST:
      return [];
    case actionTypes.FETCH_PERSONAS_SUCCESS:
      return action.ids;
    case actionTypes.CREATE_PERSONA_SUCCESS:
      return [
        ...state,
        action.ids
      ];
    default:
      return state;
  }
}

const isSaving = (state = false, action) => {
  switch(action.type){
    case actionTypes.CREATE_PERSONA_REQUEST:
      return true;
    case actionTypes.CREATE_PERSONA_SUCCESS:
    case actionTypes.CREATE_PERSONA_FAILURE:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  byId,
  ids,
  isSaving
})

const getPersonasState = state => state.personas;

export const getPersonas = state => {
  const personasState = getPersonasState(state);
  return personasState.ids.map(id => personasState.byId[id]);
}

export const getIsSaving = state => getPersonasState(state).isSaving;